import { useState, useEffect, useMemo } from "react";
import { AppBar, Toolbar } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";  

import LogoutButton from "./header/LogoutButton";
import MenuButton from "./header/MenuButton";
import NotificationButton from "./header/NotificationButton";

import "../styles/global.css/applayout.css";


export default function AppLayout({ sidebarOpen, toggleSidebar, setUser }) {
  const [isTop, setIsTop] = useState(window.innerWidth <= 1199);
  const [activeLog, setActiveLog] = useState(null);

  const notifications = useSelector(state => state.notifications.list);

  const location = useLocation();

  useEffect(() => setActiveLog(null), [location.pathname]);

  useEffect(() => {
    const handleResize = () => setIsTop(window.innerWidth <= 1199);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  const token = localStorage.getItem("token");
  const role = useMemo(() => {
    const token = localStorage.getItem("token"); 
    if (!token) return "seller";
    try {
      const decoded = jwtDecode(token);
      
       
      return String(decoded?.admin).toLowerCase() === "true" ? "admin" : "seller";
      
    } catch {
      return "seller";
    }
  }, [location.pathname]); 
   

  return (
    <div className="layout-container">
      <main className={sidebarOpen ? "main-content open" : "main-content"}>
        <AppBar position="fixed" color="transparent" className={sidebarOpen ? "header open" : "header"}>
          <Toolbar className={sidebarOpen ? "header-toolbar" : "header-toolbar-active"}>
            <MenuButton toggleSidebar={toggleSidebar} />

            <div className="header-right">
              {/* Kecici olaraq baxladim */}
              {/* {role === "admin" && <NotificationButton notifications={notifications} />} */}
              <LogoutButton setUser={setUser} role={role} />
            </div>
          </Toolbar>

        </AppBar>

        <div
          className="page-content"
          style={{ margin: `${isTop ? "70px" : "100px"} 7px 7px 7px` }}
        >
          <Outlet context={{ sidebarOpen, activeLog, setActiveLog }} />
        </div>
      </main>
    </div>
  );
}
